import { Option } from '@/modules/entity/utils/option.ts';

export const UsaPartnershipTypesOptions: Option<string>[] = [
  {
    label: 'General Partnership',
    value: 'GeneralPartnership',
  },
  {
    label: 'LP',
    value: 'LP',
  },
  {
    label: 'QTIP',
    value: 'QTIP',
  },
  {
    label: 'LLP',
    value: 'LLP',
  },
];
